import { filter, identity, isEmpty, isNil, path, pipe } from "ramda";
import Url from "url";

export const splitPath = path =>
  isNil(path) || isEmpty(path) ? [] : filter(identity, path.split("/"));

export const parsePathname = pipe(Url.parse, path(["pathname"]));

export const parsePaths = pipe(parsePathname, splitPath);

export const isValidRoute = pipe(
  parsePaths,
  paths => paths.length > 0 && paths.length <= 2,
);

export const parseProjectKey = url => {
  const paths = parsePaths(url);
  if (paths.length > 0 && paths[0] === "form") {
    return paths.length > 2 ? paths[2] : null;
  } else if (paths.length > 0) {
    return paths[0];
  } else {
    return null;
  }
};

export const parseProgramKey = url => {
  const paths = parsePaths(url);
  if (paths.length > 1 && paths[0] === "form") {
    return paths[1];
  } else {
    return null;
  }
};

export const parseOrganizationAlias = url => {
  const paths = parsePaths(url);
  if (paths.length > 1 && paths[0] === "form") {
    return paths.length > 3 ? paths[3] : null;
  } else if (paths.length > 1) {
    return paths[1];
  } else {
    return null;
  }
};
